/**
 * Shared className composition helper used by every shadcn-style component.
 * `clsx` resolves conditional class strings; `tailwind-merge` deduplicates
 * conflicting Tailwind utilities (e.g. `p-2 p-4` collapses to `p-4`).
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
